<template>
  <v-card outlined class="rounded-lg">
    <v-card-title>Anzahl {{ bezMitglieder }}</v-card-title>
      <v-row class="text-center" v-if="kontaktGruppen.length < 5">
        <v-col cols="6" :md="mdsize" v-if="index > 0" v-for="(item, index) in kontaktGruppen" :key="index">
          <h1>{{ item.count }}</h1>
          {{ item.value }}
        </v-col>
        <v-col cols="12"><v-divider></v-divider></v-col>
        <v-col cols="12"><h1>{{ kontaktGruppen[0].count }}</h1>{{ bezMitglieder }}</v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <v-simple-table dense>
            <tbody>
              <tr  v-if="index > 0" v-for="(item, index) in kontaktGruppen" :key="index">
                <td>{{ item.value }}</td>
                <td class="text-right">{{ item.count }}</td>
              </tr>
              <tr class="text-center">
                <td colspan="2">
                  <h1>{{ kontaktGruppen[0].count }}</h1>{{ bezMitglieder }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
  </v-card>
</template>

<script>
  export default {
    computed: {
      bezMitglieder () { return this.$store.getters['einstellungen/einstellung']('allgemein').bezMitglieder },
      gruppen () {
        return this.$store.getters['einstellungen/einstellung']('mitgliederstatus').status.filter(item => item.mitglied)
      },
      mdsize () {
        const size = this.gruppen.length
        switch (size) {
          case 1: return 12
          case 2: return 6
          case 3: return 4
          case 5: return 4
          default:
            return 3
        }
      },
      kontaktGruppen () {
        let gruppen = [{
          value: 'Alle',
          count: 0
        }]
        this.gruppen.forEach(gruppe => {
          gruppen.push({
            value: gruppe.status,
            count: 0
          })
        })
        const kontakte = this.$store.state.bbrbbr.bbrbbr
        kontakte.forEach(kontakt => {
          const status = kontakt.status
          let gruppe = gruppen.find(item => item.value === status)
          if (gruppe) {
            gruppe.count++
            gruppen[0].count++
          }
        })
        return gruppen
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ripuaren.vue?c431162e